import React from 'react'
import PropTypes from 'prop-types'
import SendProposalForm from 'forms/merchant/leads/send-proposal'

const SendProposal = ({ data: { id, clientId, spaceId }, handleClose, closeTitle = 'Back to Leads & Table Bookings' }) => <div className="bg-white md:my-10 w-full md:w-1/2 shadow-md md:rounded-lg m-auto md:max-w-3xl">
  <div className="p-10">
    <div className="header">
      <div className="flex items-center text-primary-orange cursor-pointer" onClick={handleClose}>
        <i className="fa fa-long-arrow-left mr-3" aria-hidden="true"></i>
        <p className="text-xs">{closeTitle}</p>
      </div>
      <div className="my-3">
        <h2 className="text-2xl font-semibold">Send Proposal</h2>
        <p className="text-primary-lightgray">
          Enter in all the details about your agreement with the client. Please note that this proposal will generate
          a payment link from which the client can pay directly once you send. Have specific T&amp;C or other
          doccuments you need to share? You can simply add as an attachment.
        </p>
      </div>
    </div>
    <SendProposalForm spaceId={spaceId} id={id} clientId={clientId} handleClose={handleClose} />
  </div>
</div>

SendProposal.propTypes = {
  data: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  closeTitle: PropTypes.string
}

export default SendProposal
